import { render, staticRenderFns } from "./ActiveMarker.vue?vue&type=template&id=afce32be&"
import script from "./ActiveMarker.vue?vue&type=script&lang=js&"
export * from "./ActiveMarker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../themes/custom/ef2_custom/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports